import { render } from "./TicketsSettings.vue?vue&type=template&id=144d53ba"
import script from "./TicketsSettings.vue?vue&type=script&lang=js"
export * from "./TicketsSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__